import React, { useContext, useMemo } from "react";
import { Link } from "react-router-dom";

// context
import { UserContext } from "../../Context/UserContextProvider";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import LogoutModal from "../../Dashboard/Logout/LogoutModal";

// styles
import styles from "./Navbar.module.css";
import NavbarDropDown from "./NavbarDropDown";

const HomeNavbar = props => {
  const { simpleUser, consultantData, permissions } = useContext(UserContext);
  const [showModal, setShowModal] = React.useState(false);
  const userInfo = useMemo(() => {
    const user = localStorage.getItem("userData");
    return JSON.parse(user);
  }, []);

  return (
    <>
      <LogoutModal show={showModal} onHide={() => setShowModal(false)} />

      <header className="container py-3 px-0" style={{ zIndex: "10" }}>
        <Navbar expand="lg" dir="rtl" className="d-flex align-items-center justify-content-around w-100 px-md-0">
          <Container
            className="px-0"
            style={{
              gap: "10px",
            }}>
            <Navbar.Brand href="#home">
              <div className="ms-4">
                <Link className={styles.logo_container} to="/">
                  <span style={{ color: props.landing ? "#FFFFFFFF" : "#21409A" }}>Azar</span>
                  <span style={{ color: props.landing ? "rgba(255, 255, 255, 0.7)" : "#127442" }}>Melk</span>
                </Link>
              </div>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="d-flex align-items-center justify-content-between w-100">
                <div className="d-flex align-items-center justify-content-center mt-md-0 mt-2">
                  <ul className="w-100 d-flex align-items-center justify-content-center flex-wrap mb-md-0 mb-3 p-0">
                    <li className={`my-2 ${styles.nav_item_li} ${props.landing && styles.landing}`}>
                      <Link className={props.navSale ? styles.nav_item_active : styles.nav_item} to="/">
                        خرید
                      </Link>
                    </li>

                    <li className={`my-2 ${styles.nav_item_li} ${props.landing && styles.landing}`}>
                      <Link to="/رهن-و-اجاره" className={props.navRent ? styles.nav_item_active : styles.nav_item}>
                        رهن و اجاره
                      </Link>
                    </li>

                    <li className={`my-2 ${styles.nav_item_li} ${props.landing && styles.landing}`}>
                      <Link className={props.blogs ? styles.nav_item_active : styles.nav_item} to="/وبلاگ">
                        بلاگ
                      </Link>
                    </li>

                    <li className={`my-2 ${styles.nav_item_li} ${props.landing && styles.landing}`}>
                      <Link className={props.Aboutus ? styles.nav_item_active : styles.nav_item} to="/درباره-ما">
                        درباره ما
                      </Link>
                    </li>

                    <li className={`my-2 ${styles.nav_item_li} ${props.landing && styles.landing}`}>
                      <Link className={props.ContactUs ? styles.nav_item_active : styles.nav_item} to="/تماس-با-ما">
                        تماس با ما
                      </Link>
                    </li>

                    <li className={`my-2 ${styles.nav_item_li} ${props.landing && styles.landing}`}>
                      <Link className={props.Hire ? styles.nav_item_active : styles.nav_item} to="/همکاری-با-ما">
                        همکاری با ما
                      </Link>
                    </li>

                    <li className={`my-2 ${styles.nav_item_li} ${props.landing && styles.landing}`}>
                      <Link className={props.commission ? styles.nav_item_active : styles.nav_item} to="/محاسبه-آنلاین-کمیسیون">
                        محاسبه آنلاین کمیسیون
                      </Link>
                    </li>

                    {/* <li className={`my-2 ${styles.nav_item_li} ${props.landing && styles.landing}`}>
                      <Link className={props.landing ? styles.landing__active : styles.nav_item} to="/خرید-خارج-از-کشور">
                        خرید خارج از کشور
                      </Link>
                    </li> */}
                  </ul>
                </div>

                <div
                  className="d-flex align-items-center justify-content-center me-4 ms-0"
                  style={{
                    height: "44px",
                  }}>
                  <div
                    className="d-flex justify-content-center align-items-center mx-2"
                    style={{
                      height: "100%",
                    }}>
                    <Link
                      to="/مشاور-ما-شوید"
                      className={`d-flex align-items-center justify-content-center ${styles.outline_btn}`}
                      style={{
                        height: "100%",
                      }}>
                      مشاور هستید؟
                    </Link>
                  </div>

                  {userInfo !== null ? (
                    <div className={`d-flex align-items-center justify-content-center ${styles.user_navbar_data_container}`}>
                      {permissions === null ? (
                        <NavbarDropDown fullName={simpleUser?.fullName} avatarName={simpleUser?.avatarName} setShowModal={setShowModal} />
                      ) : (
                        <NavbarDropDown fullName={consultantData?.fullName} avatarName={consultantData?.imageUrl} consultant setShowModal={setShowModal} />
                      )}
                    </div>
                  ) : (
                    <div className="d-flex justify-content-center align-items-center mx-2">
                      <Link to="/ورود" className={`d-flex align-items-center justify-content-center ${styles.filled_btn}`}>
                        ورود / ثبت نام
                      </Link>
                    </div>
                  )}
                </div>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  );
};

export default HomeNavbar;
